import React, { FC, useEffect, useState, memo } from "react";

import { InputAdornment } from "@components/base";
import { useUserStore } from "@store/user";
import { useGetCurrencies, useGetCurrentCompanyInfo } from "@api";

const CurrencyAdornment: FC = () => {
  const [currencySymbol, setCurrencySymbol] = useState<string>();
  const { user } = useUserStore();
  const { currentCompanyInfo } = useGetCurrentCompanyInfo(user);
  const { currencies } = useGetCurrencies(user);

  useEffect(() => {
    if (currentCompanyInfo && currencies) {
      const defaultCurrency = currencies.find(
        (currency) => currency.id === currentCompanyInfo.currencyId,
      );

      setCurrencySymbol(defaultCurrency?.alphabeticCode || "EUR");
    }
  }, [currentCompanyInfo, currencies]);

  return <InputAdornment position="end">{currencySymbol}</InputAdornment>;
};

export default CurrencyAdornment;
